import * as actionTypes from "../actions/rolesPermissions/actionTypes";

const rolesPermissions = (
  state = {
    changes: [],
    fineGranularityChanges: []
  },
  { type, payload }
) => {
  switch (type) {
    case actionTypes.SET_CHANGES:
      return Object.assign({}, state, {
        changes: payload
      });
    case actionTypes.SET_FINE_GRANULARITY_CHANGES:
      return Object.assign({}, state, {
        fineGranularityChanges: payload
      });
    case actionTypes.RESET_CHANGES:
      return Object.assign({}, state, {
        changes: [],
        fineGranularityChanges: []
      });
    default:
      return state;
  }
};

export default rolesPermissions;
